/*
 * @Descripttion: 
 * @version: 
 * @Author: hanzb
 * @Date: 2019-11-21 14:58:04
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-23 14:22:54
 */
import {
	Icon, Button, Row, Col, Menu, Pagination, Steps, Checkbox,
	Cascader, DatePicker, Form, Input, InputNumber, Radio, Switch,
	Mention, Rate, Slider, Select, TreeSelect, Transfer, TimePicker,
	Upload, Avatar, Badge, Comment, Collapse, Carousel, Card, Calendar,
	Empty, List, Popover, Tree, Tooltip, Timeline, Tag, Tabs, Table, Alert,
	Drawer, Modal, message, notification, Progress, Popconfirm, Spin, Skeleton,
	Anchor, BackTop, ConfigProvider, Divider, LocaleProvider, AutoComplete, Dropdown
} from 'antd';
const { Step } = Steps;


let sgiAntdModule = {
	"Button": Button,
	"Icon": Icon,
	"Row": Row,
	"Col": Col,
	"Menu": Menu,
	"Pagination": Pagination,
	"Steps": Steps,
	"Step": Step,
	"Checkbox": Checkbox,
	"Cascader": Cascader,
	"DatePicker": DatePicker,
	"Form": Form,
	"Input": Input,
	"InputNumber": InputNumber,
	"Mention": Mention,
	"Rate": Rate,
	"Radio": Radio,
	"Switch": Switch,
	"Slider": Slider,
	"Select": Select,
	"TreeSelect": TreeSelect,
	"Transfer": Transfer,
	"TimePicker": TimePicker,
	"Upload": Upload,
	"Avatar": Avatar,
	"Badge": Badge,
	"Comment": Comment,
	"Collapse": Collapse,
	"Carousel": Carousel,
	"Card": Card,
	"Calendar": Calendar,
	"Empty": Empty,
	"List": List,
	"Popover": Popover,
	// "Statistic": Statistic,
	"Tree": Tree,
	"Tooltip": Tooltip,
	"Timeline": Timeline,
	"Tag": Tag,
	"Tabs": Tabs,
	"Table": Table,
	"Alert": Alert,
	"Drawer": Drawer,
	"Modal": Modal,
	"message": message,
	"notification": notification,
	"Progress": Progress,
	"Popconfirm": Popconfirm,
	"Spin": Spin,
	"skeSkeleton": Skeleton,
	"Anchor": Anchor,
	"BackTop": BackTop,
	"ConfigProvider": ConfigProvider,
	"Divider": Divider,
	"LocaleProvider": LocaleProvider,
	"AutoComplete": AutoComplete,
	"Dropdown": Dropdown
}

// 初始化
if (!window.sgiAntdModule) window.sgiAntdModule = {};
// 添加方法
Object.assign(window.sgiAntdModule, sgiAntdModule);
// 导出
export default window.sgiAntdModule;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConstants/sgiAntdModule.js